import { ApiError } from "../api";
import { ErrorInfo } from "../hooks/useErrorAlert";

export default function getGenericErrorInfo(error: unknown): ErrorInfo {
  if (error instanceof ApiError) {
    if (error.status === 400) {
      return {
        title: "Problem submitting your data",
        message: "Please check your submission and try again",
      };
    } else {
      return {
        title: "Unknown error occurred",
        message:
          "Please try again, and if you’re still having issues, drop an email to support@griptonite.io",
      };
    }
  } else {
    // TODO: check more specifically for fetch errors here.
    // Otherwise we'll show a network error incorrectly if something goes wrong,
    // e.g. a bad property access
    return {
      title: "Network error occurred",
      message: "Make sure you’re connected to the internet then try again",
    };
  }
}
